import React from 'react';

import isNil from 'lodash/isNil';

import { Chip, makeStyles } from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import { SmartRuleStartPreview } from 'scenes/SmartRules/SmartRuleStartPreview';
import { useInspection } from 'scenes/SmartRules/hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
}));

export const PendingForStartLastRunResults = ({ row, openChildComponent }) => {
  const numberFormatter = useNumberFormat();
  const classes = useStyles();

  const inspection = useInspection({ data: row });
  const handleClick = React.useCallback(() => {
    openChildComponent(SmartRuleStartPreview, {
      id: row.id,
    });
  }, [row.id]);

  const label =
    !isNil(row.affectedEntitiesCount) && row.affectedEntitiesCount !== 0
      ? `${numberFormatter(row.affectedEntitiesCount)} entities`
      : 'No matches';

  return (
    <Chip
      label={label}
      variant={'outlined'}
      classes={classes}
      onClick={row.isFailed || inspection ? () => {} : handleClick}
    />
  );
};
